import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spinner-wrpr" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spinner-btn" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "loader-icon",
    alt: "loader icon",
    height: "20",
    width: "20",
    src: "/assets/persist/images/spinner-btn.png"
  })
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}